import { __assign, __extends } from "tslib";
import React from 'react';
import { getResizeMediaUrl } from '@wix/photography-client-lib';
import CommonGalleryWrapper from '../gallery/CommonGalleryWrapper';
import ProFullscreenWrapper from './StoreFullscreenWrapper'; // TODO - remove this import when the SSR can accept different bundles
import OOIStoreBannerIntent from '@wix/pro-gallery-artstore-statics/dist/src/applications/bannerOOI/bannerIntent';
import createWixSdk from '@wix/pro-gallery-artstore-statics/dist/src/applications/gallery/wixSdkOOI';
import { utils } from '../utils/webUtils';
var needToImplementError = function (funcName) {
    return "CommonStoreGalleryWrapper: you need to implement func: ".concat(funcName);
};
var CommonStoreGalleryWrapper = /** @class */ (function (_super) {
    __extends(CommonStoreGalleryWrapper, _super);
    function CommonStoreGalleryWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CommonStoreGalleryWrapper.prototype.isStoreGallery = function () {
        return true;
    };
    CommonStoreGalleryWrapper.prototype.getFullscreenElementIfNeeded = function () {
        var _this = this;
        if (!this.canRenderFullscreen()) {
            return null;
        }
        if (typeof ProFullscreenWrapper !== 'undefined') {
            return ProFullscreenWrapper;
        }
        else if (!this.FullscreenWrapper) {
            import(
            /* webpackChunkName: "StoreFullscreenWrapper" */ './StoreFullscreenWrapper').then(function (module) {
                _this.FullscreenWrapper = module.default;
                _this.setState({ fullscreenWrapperLoaded: true });
            });
        }
        return this.FullscreenWrapper || null;
    };
    CommonStoreGalleryWrapper.prototype.canRenderFullscreen = function () {
        return this.getFullscreenSelectedIndex() >= 0;
    };
    // TODO: implement if needed
    CommonStoreGalleryWrapper.prototype.getCustomIconWrapperFunc = function () {
        return undefined;
    };
    // TODO: implement if needed
    CommonStoreGalleryWrapper.prototype.getCustomSidebarWrapperFunc = function () {
        return undefined;
    };
    // TODO: need implementation
    CommonStoreGalleryWrapper.prototype.getSentryDSN = function () {
        throw new Error(needToImplementError('getSentryDSN'));
    };
    CommonStoreGalleryWrapper.prototype.getItemResizer = function (staticMediaUrls, isPrerenderMode) {
        if (this.shouldIgnoreWatermark()) {
            return getResizeMediaUrl({
                staticMediaUrls: staticMediaUrls,
                isPrerenderMode: isPrerenderMode,
            });
        }
        var watermark = this.getWatermark();
        return getResizeMediaUrl({
            imageToken: watermark,
            staticMediaUrls: staticMediaUrls,
            isPrerenderMode: isPrerenderMode,
        });
    };
    CommonStoreGalleryWrapper.prototype.getCssBaseUrl = function () {
        return utils.isLocal()
            ? 'https://localhost:3200/'
            : this.props.cssBaseUrl;
    };
    CommonStoreGalleryWrapper.prototype.getCssFilename = function () {
        return 'artStoreStaticCss.min.css';
    };
    CommonStoreGalleryWrapper.prototype.getStyleParamsForBanner = function (sp) {
        var styleParams = Object.assign({}, sp.numbers, sp.booleans, sp.colors, sp.fonts);
        styleParams.bgColorExpand = styleParams.bgColorExpand || {};
        styleParams.bgColorExpand.value = 'transparent'; // super hack B2C uses the '.shop-background' css class, instead of using transparent
        return styleParams;
    };
    CommonStoreGalleryWrapper.prototype.getWrappedProGalleryIfNeeded = function (ProGalleryElement) {
        var _this = this;
        var styleParams = this.props.host.style.styleParams;
        var bannerHeight = this.state.bannerHeight || 0;
        return (React.createElement("div", { style: { width: 'auto', minWidth: '100%' } },
            React.createElement("div", { style: {
                    height: bannerHeight,
                    visibility: bannerHeight > 0 ? 'visible' : 'hidden',
                } },
                React.createElement(OOIStoreBannerIntent, { enableStoreBanner: function (show) { return _this.enableStoreBanner(show); }, connectedProviders: this.getConnectedProviders(), galleryId: this.props.galleryId, wixSdk: this.getWixOOISdk(), styleParams: this.getStyleParamsForBanner(styleParams) })),
            ProGalleryElement));
    };
    CommonStoreGalleryWrapper.prototype.getWixOOISdk = function () {
        if (!this.wixSdk && this.getConnectedProviders()) {
            this.initWixSdkOOI(this.props);
        }
        return this.wixSdk;
    };
    CommonStoreGalleryWrapper.prototype.shouldIgnoreWatermark = function () {
        var additionalProviderParams = this.props.additionalProviderParams;
        if (additionalProviderParams && additionalProviderParams.ignoreWatermark) {
            return true;
        }
        return false;
    };
    CommonStoreGalleryWrapper.prototype.canRender = function (notInView, viewMode, galleryId, pGStyles) {
        var hasWatermark = utils.isSSR() || !!this.getWatermark() || this.shouldIgnoreWatermark();
        return (_super.prototype.canRender.call(this, notInView, viewMode, galleryId, pGStyles) && hasWatermark);
    };
    CommonStoreGalleryWrapper.prototype.initWixSdkOOI = function (_a) {
        var baseUrl = _a.baseUrl, sectionsUrls = _a.sectionsUrls, visitorId = _a.visitorId, metaSiteId = _a.metaSiteId, locale = _a.locale, _b = _a.host, formFactor = _b.formFactor, style = _b.style;
        var getDeviceType = function (type) {
            return type === 'mobile' || type === 'tablet' ? 'mobile' : 'desktop';
        };
        this.wixSdk = createWixSdk({
            baseUrl: baseUrl,
            sectionsUrls: sectionsUrls,
            visitorId: visitorId,
            metaSiteId: metaSiteId,
            locale: locale,
            deviceType: getDeviceType(formFactor.toLowerCase()),
            style: style,
        });
    };
    CommonStoreGalleryWrapper.prototype.enableStoreBanner = function (show) {
        if (show) {
            var bannerHeight = utils.isMobile() ? 200 : 430;
            this.setState({ bannerHeight: bannerHeight });
        }
        else {
            this.setState({ bannerHeight: 0 });
        }
    };
    CommonStoreGalleryWrapper.prototype.getConnectedProviders = function () {
        var _a;
        var connectedProviders = this.props.connectedProviders;
        if (connectedProviders) {
            return connectedProviders.providerId
                ? (_a = {}, _a[connectedProviders.providerId] = connectedProviders, _a) : connectedProviders;
        }
        else {
            return null;
        }
    };
    CommonStoreGalleryWrapper.prototype.getGalleryInfo = function () {
        var _a = this.props, compId = _a.compId, pageId = _a.pageId, styleId = _a.styleId, galleryId = _a.galleryId;
        return {
            compId: compId,
            pageId: pageId,
            styleId: styleId,
            hashtag: 'none',
            galleryId: galleryId,
            reachLevel: 0,
            watermarkData: this.getWatermark(),
            connectedProviders: this.getConnectedProviders(),
        };
    };
    CommonStoreGalleryWrapper.prototype.getArtStoreProps = function () {
        var _a = __assign(__assign({}, this.props.host), this.props), setActiveStoreWidget = _a.setActiveStoreWidget, changeStoreFrameState = _a.changeStoreFrameState, checkoutParams = _a.checkoutParams, pagesState = _a.pagesState, additionalProviderParams = _a.additionalProviderParams, consentPolicy = _a.consentPolicy, cartItemsData = _a.cartItemsData, storeApi = _a.storeApi, baseUrl = _a.baseUrl, galleryId = _a.galleryId, appInstance = _a.appInstance, id = _a.id;
        return {
            wixSdk: this.getWixOOISdk(),
            galleryInfo: this.getGalleryInfo(),
            onLinkNavigation: this.itemActionsHelper.onLinkNavigation,
            setActiveStoreWidget: setActiveStoreWidget,
            changeStoreFrameState: changeStoreFrameState,
            checkoutParams: checkoutParams,
            pagesState: pagesState,
            additionalProviderParams: additionalProviderParams,
            consentPolicy: consentPolicy,
            cartItemsData: cartItemsData,
            storeApi: storeApi,
            connectedProviders: this.getConnectedProviders(),
            baseUrl: baseUrl,
            galleryId: galleryId,
            id: id,
            customShopWrapper: this.getCustomSidebarWrapperFunc(),
            customIconWrapper: this.getCustomIconWrapperFunc(),
            updateUrl: this.fullscreenHelper.updateUrl,
            openEditorOnLoad: this.props.openEditorOnLoad,
            appInstance: appInstance,
        };
    };
    CommonStoreGalleryWrapper.prototype.getWatermark = function () {
        var _a = this.props, watermarkData = _a.watermarkData, watermarkWixCode = _a.watermarkWixCode;
        return watermarkWixCode || watermarkData;
    };
    return CommonStoreGalleryWrapper;
}(CommonGalleryWrapper));
export default CommonStoreGalleryWrapper;
//# sourceMappingURL=CommonStoreGalleryWrapper.js.map